/**
 * WHO WE ARE, when the server asks.
 *
 * Several endpoints record which client issued a command (`Log.ExternalAccessLog.Platform`,
 * `Log.ZezamiiAccessLog.Platform`) and the dashboard has to say so on every one of them — a remote
 * unlock that does not identify itself gets attributed to whichever client the route happens to assume,
 * which is how dashboard unlocks were logged as "App Access".
 *
 * ONE constant because the value was previously typed by hand per call site and drifted: `'dashboard'`
 * in the loggers, `'Dashboard'` with a capital D in the remote action buttons. The server keys its
 * display labels off the canonical spelling, so the capitalised rows silently lost their "Cloud Access"
 * label and fell out of every report grouped by client.
 *
 * ⚠️ This string is a WIRE VALUE, mirrored from the server's `constants/clients.js` CLIENT enum. It is
 * persisted and reported on — do not re-case it, abbreviate it, or make it a display label.
 */
export const CLIENT_DASHBOARD = 'dashboard';
